import { render, staticRenderFns } from "./ManageMarkup.vue?vue&type=template&id=360fb716&scoped=true&"
import script from "./ManageMarkup.vue?vue&type=script&lang=js&"
export * from "./ManageMarkup.vue?vue&type=script&lang=js&"
import style0 from "./ManageMarkup.vue?vue&type=style&index=0&id=360fb716&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360fb716",
  null
  
)

export default component.exports